/**
 * User-visible copy for multi-instance Cooling System list + per-unit editor (#996 Phase 2).
 * Mirrors smallUpsConfigurationsSubsectionCopy.
 */

export const COOLING_SYSTEM_CONFIGURATIONS_LIST_TITLE = 'Cooling System units';

export const COOLING_SYSTEM_CONFIGURATIONS_LIST_SUBTITLE =
  'Each row is one cooling system configuration. Select a row to edit, or add a new unit below.';

export const COOLING_SYSTEM_EDIT_DETAILS_CARD_SUBTITLE =
  'Description, capacity, redundancy, approach, and rear-door liquid options for this cooling system.';

export const COOLING_SYSTEM_EDIT_ALL_UNITS_LABEL = 'All Cooling Systems';

export const COOLING_SYSTEM_EDIT_HEADER_TITLE_NEW = 'New Cooling System';

export const COOLING_SYSTEM_EDIT_STATUS_EXISTING_LABEL = 'Existing';

export const COOLING_SYSTEM_EDIT_STATUS_NEW_LABEL = 'New';

export const COOLING_SYSTEM_EDIT_TYPE_LABEL = 'Cooling System type';

/** Display labels for {@link FormTwoOptionChoice} — map to `status` existing | new. */
export const COOLING_SYSTEM_EDIT_TYPE_OPTIONS = [
  COOLING_SYSTEM_EDIT_STATUS_EXISTING_LABEL,
  COOLING_SYSTEM_EDIT_STATUS_NEW_LABEL,
] as const;

export const COOLING_SYSTEM_EDIT_DELETE_LABEL = 'Delete';

export const COOLING_SYSTEM_EDIT_SAVE_LABEL = 'Save Cooling';

/** Create Request / draft flow — clarifies save is local to the step list. */
export const COOLING_SYSTEM_EDIT_SAVE_DRAFT_LABEL = 'Save Cooling';

export const COOLING_SYSTEM_EMPTY_STATE_TITLE = 'No Cooling added yet';

export const COOLING_SYSTEM_EDIT_SAVE_DRAFT_HINT =
  'Adds this unit to the list. Save the request separately when ready.';

export const COOLING_SYSTEM_ROW_ACTION_EDIT_LABEL = 'Edit';

export const COOLING_SYSTEM_ROW_ACTION_VIEW_LABEL = 'View';

export const COOLING_SYSTEM_ROW_ACTION_DUPLICATE_LABEL = 'Duplicate';

/** List row overflow menu — short action labels (editor footer uses {@link COOLING_SYSTEM_EDIT_DELETE_LABEL}). */
export const COOLING_SYSTEM_ROW_ACTION_DELETE_LABEL = 'Delete';

export const COOLING_SYSTEM_DELETE_CONFIRM_TITLE =
  'Delete Cooling System Configuration';

export const COOLING_SYSTEM_DELETE_CONFIRM_MESSAGE =
  'Are you sure you want to delete this cooling system configuration? This cannot be undone.';

export const COOLING_SYSTEM_DISCARD_UNSAVED_TITLE = 'Unsaved Changes';

export const COOLING_SYSTEM_DISCARD_UNSAVED_MESSAGE =
  'You have unsaved changes. Discard them?';

export const COOLING_SYSTEM_DISCARD_UNSAVED_KEEP_EDITING_LABEL = 'Stay';

export const COOLING_SYSTEM_DISCARD_UNSAVED_DISCARD_LABEL = 'Discard';
